import { Flex, Box } from '@rebass/grid';

import { Text, Heading3, Button } from 'app/shared/ui';
import { ListItems } from 'app/shared/components/ListItems/ListItems';

import { IImageWithListItemsProps } from './ImageWithListItems.types';
import { GridContainerSt, ImageContainerSt } from './ImageWithListItems.css';

export const ImageWithListItems = ({
  imageSrc,
  title,
  description,
  listItems = [],
  buttonText,
  variant = 'primary' || 'secondary',
  onButtonClick,
}: IImageWithListItemsProps): JSX.Element => {
  const isPrimary = variant === 'primary';

  return (
    <GridContainerSt>
      <Flex flexDirection="column">
        <Box mb={[24, 24, 32]}>
          <Heading3 fontSize={[32, 32, 40]} fontWeight="bold">
            {title}
          </Heading3>
        </Box>

        <Text mb={[24, 32]}>{description}</Text>

        {listItems?.length > 0 && (
          <Box mb={[32, 0]}>
            <ListItems icons={['comfort', 'cup', 'delivery']} iconSize={24}>
              {listItems.map((item) => (
                <Text
                  key={`item-${item}`}
                  fontSize={[14, 16]}
                  fontWeight="bold"
                >
                  {item}
                </Text>
              ))}
            </ListItems>
          </Box>
        )}

        {buttonText && (
          <Box>
            <Button
              variant={variant}
              width={[1, '271px']}
              onClick={onButtonClick}
            >
              {buttonText}
            </Button>
          </Box>
        )}
      </Flex>

      <ImageContainerSt imageSrc={imageSrc} gridPosition={!isPrimary} />
    </GridContainerSt>
  );
};
